import React from "react"

const ShadowContext = React.createContext({ shadowRoot: null })

export { ShadowContext }
